
<div class=" mt-4">
  <section>
    <div class="scrollmenu">
      <a [routerLink]="['/pos/businessinfo']"> Business-info </a>
      <a [routerLink]="['/pos/customer/new']"> Customer </a>
      <a routerLinkActive = "active" class="active menu" [routerLink]="['/pos/Employee/new']"> Employee </a>
      <a [routerLink]="['/pos/orders/new']"> Orders</a>
      <a [routerLink]="['/pos/taxfee/new']"> Tax Fee </a>
      <a [routerLink]="['/pos/category/new']"> Item-Category </a>
      <a [routerLink]="['/pos/item/new']"> Items </a>
      <a [routerLink]="['/pos/businesshour/new']"> Business-Hours </a>
      <!-- <a [routerLink]="['/pos/order/new']"> Order </a>
      <a [routerLink]="['/pos/orderreceipt/new']"> Order Receipt </a>
      <a [routerLink]="['/pos/payment/new']"> Payment </a>
      <a [routerLink]="['/pos/paymentrecipt/new']"> Payment Receipt </a>
      <a [routerLink]="['/pos/tip/new']"> Tips </a> -->
      
        <!--  <a [routerLink]="['/pos/orderregister']"> Order Register </a>  -->
        <!--  <a [routerLink]="['/pos/ordertype/new']"> Order Type </a> -->
        <!--   <a [routerLink]="['/pos/tender/new']">  Tender </a>  -->
  </div>

  </section>
  <section class="mt-2">
      <div class="">
          <div class="row">
              <div class="col-md-12">
                  <div class="text-right py-2">
                    <button class="btn dash-btns"  [routerLink]="['/pos/employee/manage']">Manage Employee</button>

                  </div>
              </div>
              <div class="col-md-7">
                  <div class="card-1">
                      <div class="row">
                          <div class="col-md-12">
                              <!-- <div class="text-center mb-5">
                                  <img src="assets/img/new/view-trans.svg" />
                              </div> -->
                              <div class="text-center">
                                   
                                  <div class="col-md-12"  *ngIf="isNewEmployee">
                                    <a class="view-h gary-t  ">Lets create a  new Employee here</a>
                                </div>
                                <div class="col-md-12"   *ngIf="isUpdateEmployee">
                                  <a class="view-h gary-t  ">Lets Update Employee here.</a>
                              </div>
                              </div>

                              <div class="py-3">

                                <div class="col-md-12"   *ngIf="isNewEmployee">
                                  <form #fnewprepaidcard="ngForm">
                                    <div>
                                      <form #form="ngForm" class="addpaynow">
                                        <div class="form-group formgroup-tm">
              
                                            <div class="row pt-2"> 
                                                  
                                                  <div class="col-md-12">
                                                   
                                                    <div class="form-group formgroup-tm"> 
                                                      <label class="customlabel">Employee Id*</label>
                                                      <input class="formcontrol-user1 form-control" type="text" placeholder="Employee Id" id="EmployeeId" name="EmployeeId" [formControl]="EmployeeId" (change)=onChange()
                                                      required>
                                                  
                                                </div>
                                                
                                                  <span class="text-danger" *ngIf="EmployeeId.invalid && (EmployeeId.dirty || EmployeeId.touched)">{{employeeIdIderrors()}}</span>
                                           
                                                  <div style="color:red;" *ngIf="isemployee">Employee Id is already exist</div>   </div>
                                            </div>
                                            
                                            <div class="row pt-2"> 
                                                  
                                                  <div class="col-md-12">
                                                    <div class="form-group formgroup-tm">
                                                      <label class="customlabel">First Name*</label>
                                                      <input class="formcontrol-user1 form-control" type="text" placeholder="First Name" id="FirstName" name="FirstName" [formControl]="FirstName" required>
                                                     
                                                    </div>
                                                    <span class="text-danger" *ngIf="FirstName.invalid && (FirstName.dirty || FirstName.touched)">{{firstNameError()}}</span>
                                                </div>
                                            </div>
                                            <div class="row pt-2"> 
                                                  
                                                  <div class="col-md-12">
                                                   
                                                    <div class="form-group formgroup-tm">
                                                      <label class="customlabel">Last Name*</label>
                                                      <input class="formcontrol-user1 form-control" type="text" placeholder="Last Name" id="LastName" name="LastName" [formControl]="LastName" required>
                                  
                                                    </div>
                                                    <span class="text-danger" *ngIf="LastName.invalid && (LastName.dirty || LastName.touched)">{{lastNameError()}}</span>
                                                </div>
                                            </div>
              
                                            <div class="row pt-2"> 
                                                  
                                                  <div class="col-md-12">
                                                   
                                                    <div class="form-group formgroup-tm">
                                                      <label class="customlabel">Nick Name  </label>
                                                      <input class="formcontrol-user1 form-control" type="text" placeholder="Nick Name" id="NickName" name="NickName" maxlength="10" [formControl]="NickName">
                                                     
                                                </div>
                                            
                                            </div>
                                            </div>
                                            <div class="row pt-2">
               
                                                  
                                                  <div class="col-md-12">
                                                    
                                                    <div class="form-group formgroup-tm"> 
                                                      <label class="customlabel">Email</label>
                                                      <input class="formcontrol-user1 form-control" type="text" placeholder="Email" id="Email" name="Email" pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$" (change)="onChangeid()"
                                                      [formControl]="Email">
                                                    <!-- <mat-error *ngIf="email.invalid">{{Emailerrors()}}</mat-error> -->
                                    
                                                    </div>
                                                    <div style="color:red;" *ngIf="Emailerror">Email  already exist</div>
                                                    <span class="text-danger" *ngIf="Email.invalid && (Email.dirty || Email.touched)">{{Emailerrors()}}</span>
                                                </div>
                                            </div>
                                           
                                            <div class="row pt-2">
                                                  
                                                  <div class="col-md-12">
                                                   
                                                    <div class="input-group form-group formgroup-tm prefix mb-0"> 
                                                      <label class="customlabel">Contact Number*</label>
                                                      <span class="input-group-addon" *ngIf="currency =='$'">+1</span>
                                                      <span class="input-group-addon" *ngIf="currency =='₹'">+91</span>
                                                      <input class="formcontrol-user1 form-control w-100"  type="tel" placeholder="Contact Number" id="PhoneNo" name="PhoneNo" maxlength="10" [formControl]="PhoneNo" required (change)="onChangemobile()">
                                                      <!-- <mat-error *ngIf="phoneNo.invalid">{{phoneNoerrors()}}</mat-error> -->
                                                    </div>
                                                    <div style="color:red;" *ngIf="mobileerror">Mobile Number  already exist</div>
                                                    <!-- <span class="text-danger" *ngIf="phoneNo.invalid && (phoneNo.dirty || phoneNo.touched)">{{phoneNoerrors()}}</span> -->
                                                    <span *ngIf="mobileerrorvalidation" class="text-danger">
                                                      {{Mobileerrormessage}}
                                                   </span>
                                                </div>
                                            </div>
              
                                            <div class="row pt-2"> 
                                                
                                                <div class="col-md-12">
                                                 
                                                  <div class="form-group formgroup-tm"> 
                                                    <label class="customlabel">Pass Code*</label>
                                                    <input class="formcontrol-user1 form-control" type="password" placeholder="Pass Code" id="PassCode" name="PassCode" maxlength="4" [formControl]="PassCode">
                   
                                                  </div>
                                                  <span class="text-danger" *ngIf="PassCode.invalid && (PassCode.dirty || PassCode.touched)">{{passCodeerrors()}}</span>
                                              </div>
                                          </div>
                                          <div class="row pt-2"> 
                                            
                                            <div class="col-md-12">
                                             
                                              <div class="form-group formgroup-tm"> 
                                                <!-- <input class="formcontrol-user1 form-control" type="text" placeholder="Role" id="Role" name="role"  [formControl]="role" required>
                                                -->
                                                <label class="customlabel">Role*</label>
                                                <div class="selectcustom mb-0">
                                                  <ngx-select [items]="Type" placeholder="Role" id="Role" name="Role"  [formControl]="Role" required>
                                                  </ngx-select>
                                                </div>
                                               
                                              </div>
                                              <span class="text-danger" *ngIf="Role.invalid && (Role.dirty || Role.touched)">{{roleerrors()}} </span>
                                             
                                          </div>
                                      </div>
                                   
              
                                            <div class="pt-3">
                                                <button class="btn dash-btns" type="button" id="customer" color="primary" 
                                                [disabled]="EmployeeId.invalid||FirstName.invalid||LastName.invalid||Email.invalid ||mobileerror ||PassCode.invalid ||Emailerror||mobileerrorvalidation||Role.invalid"
                                                (click)="newEmployee()">Submit</button>
              
                                            </div>
              
                                        </div>
                                    </form>
                                    </div>
                                  </form>
                                 
                                </div>
          
                                <div class="col-md-12"  *ngIf="isUpdateEmployee">
                                  <form #fnewprepaidcard="ngForm">
                                    <div>
                                      <form #form="ngForm" class="addpaynow">
                                        <div class="form-group formgroup-tm">
          
                                            <div class="row pt-2"> 
                                                 
                                                  <div class="col-md-12">
                                                    
                                                    <div class="form-group formgroup-tm"> 
                                                      <label class="customlabel">Employee Id*</label>
                                                      <input class="formcontrol-user1 form-control" type="text" placeholder="Employee Id" id="employeeId" name="employeeId" [(ngModel)]="rows.employeeId" [formControl]="EmployeeId" (change)=onChange()
                                                      readonly>
                                                  
                                                </div>
                                                
                                                  <span class="text-danger" *ngIf="EmployeeId.invalid && (EmployeeId.dirty || EmployeeId.touched)">{{employeeIdIderrors()}}</span>
                                            </div>
                                            </div>
                                            
                                            <div class="row pt-2"> 
                                                 
                                                  <div class="col-md-12">
                                                    
                                                    <div class="form-group formgroup-tm">
                                                      <label class="customlabel">First Name*</label>
                                                      <input class="formcontrol-user1 form-control" type="text" placeholder="First Name" id="firstName" name="firstName" [(ngModel)]="rows.FirstName" (keydown)="onKey()" [formControl]="FirstName" required>
                                                     
                                                    </div>
                                                    <span class="text-danger" *ngIf="FirstName.invalid && (FirstName.dirty || FirstName.touched)">{{firstNameError()}}</span>
                                                </div>
                                            </div>
                                            <div class="row pt-2"> 
                                                 
                                                  <div class="col-md-12">
                                                    <label class="customlabel">Last Name*</label>
                                                    <div class="form-group formgroup-tm">
                                                      <input class="formcontrol-user1 form-control" type="text" placeholder="Last Name" id="lastName" name="lastName" [(ngModel)]="rows.LastName" (keydown)="onKey()" [formControl]="LastName" required>
                                  
                                                    </div>
                                                    <span class="text-danger" *ngIf="LastName.invalid && (LastName.dirty || LastName.touched)">{{lastNameError()}}</span>
                                                </div>
                                            </div>
          
                                            <div class="row pt-2"> 
                                                 
                                                  <div class="col-md-12">
                                                    
                                                    <div class="form-group formgroup-tm">
                                                      <label class="customlabel">Nick Name  </label>
                                                      <input class="formcontrol-user1 form-control" type="text" placeholder="Nick Name" id="NickName" name="NickName" maxlength="10" [(ngModel)]="rows.NickName" (keydown)="onKey()" [formControl]="NickName">
                                                     
                                                </div>
                                            
                                            </div>
                                            </div>
                                            <input type="hidden" [(ngModel)]="rows.Id" id="id" name="id"  [formControl]="id" >
                                            <input type="hidden" [(ngModel)]="rows.dateTime" id="date" name="date"  [formControl]="date" >
                                            <div class="row pt-2"> 
                                                 
                                                  <div class="col-md-12">
                                                    
                                                    <div class="form-group formgroup-tm"> 
                                                      <label class="customlabel">Email</label>
                                                      <input class="formcontrol-user1 form-control" type="text" placeholder="Email" id="email" name="email" [(ngModel)]="rows.Email" (keydown)="onKey()" pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,4})+$" (change)="onChangeid()"
                                                      [formControl]="Email">
                                                    <!-- <mat-error *ngIf="email.invalid">{{Emailerrors()}}</mat-error> -->
                                    
                                                    </div>
                                                    <div style="color:red;" *ngIf="Emailerror">Email  already exist</div>
                                                    <span class="text-danger" *ngIf="Email.invalid && (Email.dirty || Email.touched)">{{Emailerrors()}}</span>
                                                </div>
                                            </div>
                                           
                                            <div class="row pt-2"> 
                                                 
                                                  <div class="col-md-12">
                                                   
                                                    <div class="input-group form-group formgroup-tm prefix"> 
                                                       <label class="customlabel">Contact Number*</label>
                                                      <span class="input-group-addon" *ngIf="currency =='$'">+1</span>
                                                      <span class="input-group-addon" *ngIf="currency =='₹'">+91</span>
                                                      <input class="formcontrol-user1 form-control w-100"  type="tel" placeholder="Contact Number" id="phoneNo" name="phoneNo" [(ngModel)]="rows.PhoneNo" (keydown)="onKey()" maxlength="10" [formControl]="PhoneNo" required (change)="onChangemobile()">
                                                      <!-- <mat-error *ngIf="phoneNo.invalid">{{phoneNoerrors()}}</mat-error> -->
                                                    </div>
                                                    <div style="color:red;" *ngIf="mobileerror">Mobile Number  already exist</div>
                                                    <span *ngIf="mobileerrorvalidation" class="text-danger">
                                                      {{Mobileerrormessage}}
                                                   </span>
                                                    <!-- <span class="text-danger" *ngIf="phoneNo.invalid && (phoneNo.dirty || phoneNo.touched)">{{phoneNoerrors()}}</span> -->
                                                </div>
                                            </div>
          
                                            <div class="row pt-2"> 
                                               
                                                <div class="col-md-12">
                                                 
                                                  <div class="form-group formgroup-tm"> 
                                                    <label class="customlabel">Pass Code*</label>
                                                    <input class="formcontrol-user1 form-control" type="password" placeholder="Pass Code" id="passCode" name="passCode" maxlength="4" [(ngModel)]="rows.passCode" (keydown)="onKey()" [formControl]="PassCode">
                   
                                                  </div>
                                                  <span class="text-danger" *ngIf="PassCode.invalid && (PassCode.dirty || PassCode.touched)">{{passCodeerrors()}}</span>
                                              </div>
                                          </div>
                                          <div class="row pt-2"> 
                                           
                                            <div class="col-md-12">
                                             
                                              <div class="form-group formgroup-tm"> 
                                                <!-- <input type="text" placeholder="Role" id="phoneNo" name="role"  [formControl]="role" [(ngModel)]="rows.role" required>
                                                -->
                                                <label class="customlabel">Role*</label>
                                                <div class="selectcustom mb-0">
                                                  <ngx-select [items]="Type" placeholder="Role" id="Role" name="role"  [formControl]="Role" [(ngModel)]="rows.Role" (select)="onKey()" required>
                                                  </ngx-select>
                                                </div>
                                               
                                              </div>
                                              <!-- <span class="text-danger" *ngIf="Role.invalid && (Role.dirty || Role.touched)">{{roleerrors()}} </span> -->
                                          </div>
                                      </div>
                                   
          
                                            <div class="pt-3">
                                                <button class="btn dash-btns" type="button" id="customer" color="primary" 
                                                [disabled]="FirstName.invalid||LastName.invalid||Email.invalid ||mobileerrorvalidation ||PassCode.invalid ||Emailerror||mobileerror||!isReadytoUpdateEmployee"
                                                (click)="updateEmployee()">Update</button>
          
                                            </div>
          
                                        </div>
                                    </form>
                                    </div>
                                  </form>
                                 
                                </div>
                           

                            


                              </div>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="col-md-5">
                <div class="card p-2">
                    <div class="text-center">
                       <img src="https://fastswiff.com/assets/img/easytouse.png"   class="w-100" alt="">
                    </div>
                </div>
            </div>
          </div>
      </div>
  </section>

</div>















<!-- 
<section  >
  <div class="block-header">
      <div class="container">
          <div class="row ">
              <div class="col-md-12  p-0">
                  <h2 class="poppins font-weight-bold pl-2">  Employee</h2>
              </div>
              <div class=" col-md-5 px-6 col-sm-12 p-0">

                  <div class="breadcrumb flat">
                    <a [routerLink]="['/pos']">
                      
                      Home
                  </a>
                  <a href="#" class="active">New Employee</a>
                  </div>
              </div>
              <div class="col-md-7">
                  <div class="float-right">
                     
                  </div>
              </div>
          </div>
      </div>

  </div>
  <div class="container">
      <div class="row">
          <div class="col-md-12 p-0">
              <div class=" card px-2 py-4 poppins border" style="box-shadow: none; border-radius: 10px;">
                  <div class="row mx-0">
                    
                       
                  </div>
                  <div class="row mx-0">
                       

                   

                      <div class="col-md-5">
                          <div class="b">
                              <img src="assets/img/payment-solutions.png" alt="Tips"
                                  style="display: block; width: 100%;">
                          </div>
                          
                      </div>



                  </div>
              </div>
          </div>
      </div>
  </div>
</section>  -->













 




 